var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import axios from "axios";
import CONSTS from "../../consts";
export default class HeroBanner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCollection: {}
        };
    }
    getCollection() {
        return __awaiter(this, void 0, void 0, function* () {
            let oDataPath = CONSTS.APIURL;
            let query = `${oDataPath}Collections(${this.props.id})`;
            const response = yield axios.get(query);
            this.setState({
                selectedCollection: response.data
            });
        });
    }
    componentDidMount() {
        this.getCollection();
    }
    render() {
        let collectionDetails = this.state
            .selectedCollection;
        return (collectionDetails.Active ? React.createElement("a", { href: this.props.overrideLink ? this.props.overrideLink : ('/Products/Collections/' + collectionDetails.Id) },
            React.createElement("div", { className: "hero-banner" },
                React.createElement("div", { className: "hero-banner__img", style: {
                        backgroundImage: `url('${CONSTS.STORAGEURL}/${CONSTS.COLLECTIONCONTAINER}/` +
                            collectionDetails.Id +
                            ".jpg')"
                    } }),
                React.createElement("div", { className: "hero-banner__wrap" },
                    React.createElement("div", { className: "hero-banner__content" },
                        React.createElement("p", { className: "header-text" }, collectionDetails.Name),
                        React.createElement("p", { className: "banner-text" }, collectionDetails.Title),
                        React.createElement("p", { className: "sub-text" }, collectionDetails.Description),
                        React.createElement("span", { className: "btn-primary btn-primary__party" }, collectionDetails.ButtonText || "Click Here"))))) : null);
    }
}
//# sourceMappingURL=hero-banner.js.map